import type { MouseEvent } from 'react'
import { Link } from 'react-router-dom'

import { withServiceInstanceId } from '@/lib/service-instance'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/stores/auth-store'

export function WorkerProfileLink({
  workerId,
  name,
  className,
}: {
  workerId?: string | number | null
  name: string
  className?: string
}) {
  const serviceInstanceId = useAuthStore((state) => state.serviceInstanceId)
  const label = name.trim() || 'Worker'
  const stopRowClick = (event: MouseEvent) => event.stopPropagation()

  if (workerId == null || String(workerId).trim() === '') {
    return <span className={className}>{label}</span>
  }

  return (
    <Link
      to={withServiceInstanceId(`/workers/${workerId}`, serviceInstanceId)}
      className={cn('underline-offset-2 hover:text-primary hover:underline', className)}
      onClick={stopRowClick}
    >
      {label}
    </Link>
  )
}
